export const DEFAULT_LOCALE = 'zh_CN';
